// ─── src/components/TopSectionManager.js ──────────────────────────────
import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { getUserDetails } from "../../services/authService";
import "./TopSectionManager.css";

const DEFAULT_AVATAR = "/icons/default_user.png";   // ← put file in public/icons

export default function TopSectionManager({
  eventName,
  eventDate,
  eventLocation,
  eventId,
  eventType,
  introImageUrl,
  onCopyLink,           // ①  new prop
  onShareLink              // ②  new prop
}) {
  const history    = useHistory();
  const userId     = localStorage.getItem("user_id");
  const [userData, setUserData] = useState(null);
  const [loading,  setLoading ] = useState(false);

  /* ───── fetch once ───── */
  useEffect(() => {
    if (!userId) return;
    let cancel = false;
    setLoading(true);
    (async () => {
      try {
        const res = await getUserDetails(userId);
        if (!cancel && res.success) setUserData(res.user);
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, [userId]);

  /* ───── helpers ───── */
  const managementType =
    userData?.management_type ||
    localStorage.getItem("management_type") ||
    "photographer";

  const isEventManager = managementType === "event_manager";

  const avatarSrc =
    userData?.photographer_profile?.image_url?.trim() || DEFAULT_AVATAR;

  const showUserIcon = !isEventManager && !loading;   // ← key condition

  const handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = DEFAULT_AVATAR;
  };

  const handleUserClick = () => {
    if (!userId) return history.push("/login");
    if (loading || !userData) return;
    history.push(`/user-details/${userId}`, { to_update: true, userData });
  };

  const handleEditClick = () => {
    history.push("/update-event", {
      event_id:        eventId,
      event_name:      eventName,
      event_date:      eventDate,
      event_location:  eventLocation,
      event_type:      eventType,
      intro_image_url: introImageUrl,
    });
  };

  /* ───── render ───── */
  return (
    <div
      className="top-section-manager blur-background blur-top"
      style={{
        "--circle-size":  "200px",
        "--translate-x": "-120%",
        "--translate-y":  "-30%",
      }}
    >
      {/* logo + (optional) user */}
      <div className="logo-container-manager">
        {/* Logo */}
        <div className="logo-container-top">
          <Link to="/">
            <img src="/icons/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        {/* User icon – rendered only when showUserIcon === true */}
        {showUserIcon && (
          <div
            className="user-image-container-manager"
            onClick={handleUserClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleUserClick()}
            style={{ cursor: loading ? "default" : "pointer" }}
          >
            <img
              src={avatarSrc}
              alt="User avatar"
              className="user-avatar"
              onError={handleImgError}
            />
          </div>
        )}
      </div>

      {/* title + details */}
      <div className="top-title-manager">
        <span className="event-name-container">
          {eventName || "שם אירוע לא צוין"}
        </span>

        <div className="event-details-container">
          <div className="event-date-container">
            <img src="/icons/date.png" className="date-image" alt="Date" />
            <div className="event-date-text">
              {eventDate || "תאריך לא צוין"}
            </div>
          </div>
          <div className="event-location-container">
            <img src="/icons/location.png" className="location-image" alt="Location" />
            <div className="event-location-text">
              {eventLocation || "מיקום לא צוין"}
            </div>
          </div>
        </div>

        {/* edit + extra buttons */}
        <div className="manager-btn-group">
          <button type="button" className="edit-btn-manager" onClick={handleEditClick}>
            <img src="/icons/edit-circle.png" className="edit-image-manager" alt="ערוך אירוע" />
          </button>

          {/* NEW – copy-link + QR buttons */}
          <button
            type="button"
            className="top-extra-btn edit-btn-manager"
            onClick={onCopyLink}
            title="העתק קישור"
          >
            <img src="/icons/link_white.png" className="extra-img" alt="Copy link" />
          </button>

          <button
            type="button"
            className="top-extra-btn edit-btn-manager"
            onClick={onShareLink}
            title="שתף לינק"
          >
            <img src="/icons/share_white.png" className="extra-img2" alt="Share link" />
          </button>
        </div>
      </div>
    </div>
  );
}
